import { newE2EPage } from "@stencil/core/testing";

const testMenuItemsNested = [
    {
        name: "item-1-1",
        label: "Item 1-1"
    },
    {
        name: "item-1-2",
        label: "Item 1-2"
    }
];

describe("uic-header-menu-item", () => {
    it("should render menu item as link with href, target and download attributes", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <uic-header-menu-item
                name="test-link"
                href="/test-image.jpg"
                download="test-image.jpg"
                label="Test Link"
            ></uic-header-menu-item>
        `);
        const el = await page.find("uic-header-menu-item.hydrated");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render nested items correctly", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <uic-header-menu-item
                name="test-nested"
                label="Test Nested"
            ></uic-header-menu-item>
        `);
        const el = await page.find("uic-header-menu-item.hydrated");
        el.setProperty("items", testMenuItemsNested);
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should not render label text if menu item has slot content", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <uic-header-menu-item
                name="test-label"
                label="Test Label Text"
            >Test Label Slot</uic-header-menu-item>
        `);
        const el = await page.find("uic-header-menu-item.hydrated");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });
});
